export const name = 'customCss' as const
export const CustomCssAPISymbol = Symbol('CustomCssAPISymbol')
export const CustomCssDsAPISymbol = Symbol('CustomCssDsAPISymbol')
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
